import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ControlDeletionService {
    constructor(private http: HttpClient) { }

    private _deleteBtnCondition = new BehaviorSubject<boolean>(false);
    deleteBtnCondition = this._deleteBtnCondition.asObservable();

    toggleDeleteBtn(toggleBtn: boolean) {
        this._deleteBtnCondition.next(toggleBtn);
    }

    getDeleteBtnCondition() {
        return this._deleteBtnCondition;
    }

    private _toBeDeletedRows = new BehaviorSubject<any>({});
    toBeDeletedRows = this._toBeDeletedRows.asObservable();

    setDeletedRows(rows) {
        this._toBeDeletedRows.next(rows);
    }

    getDeletedRows() {
        return this._toBeDeletedRows;
    }


    private _resetSelectedRows = new BehaviorSubject<boolean>(false);
    ResetSelectedRows = this._resetSelectedRows.asObservable();

    resetSelectedRows() {
        this._resetSelectedRows.next(true);
    }

    getResetSelectedRows() {
        return this._resetSelectedRows;
    }


    private _checkbox = new BehaviorSubject<Array<any>>([]);
    Checkbox = this._checkbox.asObservable();

    setCheckbox(checkbox) {
        this._checkbox.next(checkbox);
    }

    getCheckbox() {
        return this._checkbox;
    }
}